var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEmployee = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "person_black_24dp_5_",
    "data-name": "person_black_24dp (5)",
    width: 21.996,
    height: 21.996,
    viewBox: "0 0 21.996 21.996",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8279",
    "data-name": "Path 8279",
    d: "M0,0H22V22H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8280",
    "data-name": "Path 8280",
    d: "M11.332,11.332A3.666,3.666,0,1,0,7.666,7.666,3.665,3.665,0,0,0,11.332,11.332Zm0,1.833C8.885,13.165,4,14.393,4,16.831v.917a.919.919,0,0,0,.917.917H17.748a.919.919,0,0,0,.917-.917v-.917C18.664,14.393,13.779,13.165,11.332,13.165Z",
    transform: "translate(-0.334 -0.334)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmployee, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/employee.905199a3.svg";
export { ForwardRef as ReactComponent };